<template>
<div class="box_center" id="page_x">
  <div id="feedback" v-if="errors.any() || error">
    <p class="error wrong_name error-box" v-if="errors.has('username')">Please enter your email</p>
    <p class="error wrong_email error-box" v-if="errors.has('password')">Please enter a password</p>
    <p class="error wrong_email error-box" v-if="error">{{error}}</p>
  </div>
  <div class="input">
    <form @submit.prevent="login" name="login">
      <p class="text_form">
        Email: <br />
        Password:
      </p>
      <input type="text" name="username" class="contact_form" v-model="username" v-validate="'required'" data-vv-delay="2000" autofocus/>
      <input type="password" name="password" class="contact_form" v-model="password" v-validate="'required'" data-vv-delay="2000"/>
      <input type="submit" value="Login" name="submitButton" title="Login" class="button submit">
    </form>
    <p>Not a member? <router-link :to="{path: '/register'}">Click here to register for free.</router-link></p>
    <br />
    <p><router-link :to="{path: '/forgotpassword'}"> Forgot Password?</router-link></p>
  </div>
</div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      username: '',
      password: '',
      error: '',
      package: '',
      cookiesEnabled: true
    }
  },
  mounted () {
    this.package = this.$route.query.package
    let savedUsername = ''
    try {
      savedUsername = Cookies.get('sts_username')
    } catch (e) {
      this.cookiesEnabled = false
      console.log(e)
    }
    if (savedUsername) {
      this.username = savedUsername
    }
  },
  methods: {
    login () {
      this.$validator.validateAll().then(() => {
        this.$store.dispatch('login', {email: this.username, password: this.password}).then((user) => {
          if (this.cookiesEnabled) {
            Cookies.set('sts_username', this.username, { expires: 120 })
          }
          if (this.package) {
            this.$router.push({path: '/purchase', query: {package: this.package}})
          } else {
            this.$router.push('/')
          }
        }).catch(() => {
          this.error = 'Login failed...'
        })
      }).catch((err) => { console.log(err) })
    }
  },
  metaInfo: {
    title: 'Login'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Login.vue?b6d0c0ea